import { call, put, takeLatest } from "redux-saga/effects";
import Swal from "sweetalert2";
import * as types from "./actionTypes";
import { post, get } from "../../../helpers/api_helper";

function* fetchEmployeeResignationSaga(action) {
  try {
    const formData = new FormData();
    formData.append("unit_id", action.payload?.unit_id);
    const response = yield call(post, process.env.REACT_APP_GET_EMPLOYEE_RESIGNATION, formData);
    yield put({ type: types.FETCH_EMPLOYEE_RESIGNATION_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire({
      title: "Error",
      text: error.message || "Something went wrong while fetching resignation data!",
      icon: "error",
      confirmButtonText: "OK",
    });
    yield put({ type: types.EMPLOYEE_RESIGNATION_FAILURE, payload: error });
  }
}

function* saveEmployeeResignationSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_EMPLOYEE_RESIGNATION, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to save resignation!");
    }

    Swal.fire({
      title: "Success",
      text: response?.message,
      icon: "success",
      confirmButtonText: "OK",
    });

    yield put({ type: types.SAVE_EMPLOYEE_RESIGNATION_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire({
      title: "Error",
      text: error.message || "Something went wrong while saving resignation!",
      icon: "error",
      confirmButtonText: "OK",
    });
    yield put({ type: types.EMPLOYEE_RESIGNATION_FAILURE, payload: error });
  }
}

function* saveEmployeeRejoinSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_EMPLOYEE_REJOIN, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to process rejoin!");
    }

    Swal.fire({
      title: "Rejoin Successful",
      text: response?.message,
      icon: "success",
      confirmButtonText: "OK",
    });

    yield put({ type: types.SAVE_EMPLOYEE_REJOIN_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire({
      title: "Error",
      text: error.message || "Something went wrong while processing rejoin!",
      icon: "error",
      confirmButtonText: "OK",
    });
    yield put({ type: types.EMPLOYEE_RESIGNATION_FAILURE, payload: error });
  }
}

export default function* employeeResignationSaga() {
  yield takeLatest(types.FETCH_EMPLOYEE_RESIGNATION, fetchEmployeeResignationSaga);
  yield takeLatest(types.SAVE_EMPLOYEE_RESIGNATION, saveEmployeeResignationSaga);
  yield takeLatest(types.SAVE_EMPLOYEE_REJOIN, saveEmployeeRejoinSaga);
}
